import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { emptyString, buttonGroupConstant, BRAND_PERFORMANCE_DISPLAY } from "../../constants";

const { GROUP, STORE } = buttonGroupConstant;

const PerformanceButtonGroup = (props) => {
  const { handleChangeResponse, selectedResponse, windowSize } = props;

  return (
    <div className="text-center container pb-3">
      <ButtonGroup className="button-group-toogle">
        <Button
          onClick={(e) => handleChangeResponse(e.target.value)}
          value={GROUP}
          className={`${
            selectedResponse === GROUP
              ? "toggle-button-label-selected"
              : "btn toggle-button-label"
          } ${windowSize < BRAND_PERFORMANCE_DISPLAY.MOBILE_BUTTON_BREAKPOINT ? "button-mobile-width" : emptyString}`}
        >
          Groups
        </Button>
        <Button
          onClick={(e) => handleChangeResponse(e.target.value)}
          value={STORE}
          className={`${
            selectedResponse === STORE
              ? "toggle-button-label-selected"
              : "btn toggle-button-label"
          } ${windowSize < BRAND_PERFORMANCE_DISPLAY.MOBILE_BUTTON_BREAKPOINT ? "button-mobile-width" : emptyString}`}
        >
          Stores
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default PerformanceButtonGroup;
